// Module
var code = "<div ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"> <i class=\"material-icons hover close-modal no-expand\" ng-class=\"{show: hover}\" ng-click=\"$ctrl.closeModal()\"> remove </i> <nets-call-park-list context=\"modal\" workflow=\"fab\"></nets-call-park-list> </div> ";
// Exports
export default code;